/**
 * Height of the main chart on a dashboard page: what the window leaves once the
 * header, the figures and the top lists under the chart have their room, so the
 * whole page fits on one screen. Legacy sized it the same way
 * (`setMainChartHeight`: window height − 600, at least 300).
 */
export const MAIN_CHART_HEIGHT = 'max(300px, calc(100dvh - 600px))';
